export { DMS_MODULE } from '../constants';
export const NAME = 'WmsReception';
export const API_NAME = 'WmsReception';
export const CRUMB_LABEL_KEY = 'WmsReception';
